export const LOCAL_KEY = {
	deviceId: "deviceId",
};
